<div class="vw-100 vh-100">
    <div class="row justify-content-center">
        <div class="col-sm-8 col-md-4 col-lg-3">
            <div class="card w-auto mt-5 mb-5">
                <div class="card-header">
                    Welcome
                </div>
                <div class="card-body text-center">
                    <a href="/login" class="btn btn-primary btn-block mt-3 mb-3">
                        <span class="fas fa-sign-in-alt"></span> Login
                    </a>
                </div>
            </div>   
        </div>
    </div>
</div>